import React from 'react'

const ProgressBar = ({ progress }) => {
  return (
   <div className="progress-section">
      <p className="progress-text">{progress}%</p>

      <div className="progress-track">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressBar